import React, { useEffect } from "react";
import PropTypes from "prop-types";
import styles from "./ImageCarousel.module.css";
import { Carousel } from "bootstrap";

export default function ImageCarousel({ imgs }) {
  useEffect(() => {
    const carouselElement = document.getElementById("imgCarousel");
    if (carouselElement) {
      new Carousel(carouselElement, {
        interval: 3000,
        ride: "carousel",
      });
    }
  }, []);

  return (
    <div className={styles.imgCarousel}>
      <div className="carousel slide" id="imgCarousel" data-bs-ride="carousel">
        <div className="carousel-indicators">
          {imgs.map((img, index) => (
            <button
              key={index}
              type="button"
              data-bs-target="#imgCarousel"
              data-bs-slide-to={index}
              className={index === 0 ? "active" : ""}
              aria-current={index === 0 ? "true" : undefined}
              aria-label={`Slide ${index + 1}`}
            ></button>
          ))}
        </div>
        <div className="carousel-inner">
          {imgs.map((img, index) => (
            <div
              className={`carousel-item ${index === 0 ? "active" : ""}`}
              key={index}
            >
              <img
                className={styles.image}
                src={img.src}
                alt={img.alt || `Image ${index}`}
              />
            </div>
          ))}
        </div>
        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target="#imgCarousel"
          data-bs-slide="prev"
        >
          <span
            className="carousel-control-prev-icon"
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#imgCarousel"
          data-bs-slide="next"
        >
          <span
            className="carousel-control-next-icon"
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>
    </div>
  );
}

ImageCarousel.propTypes = {
  imgs: PropTypes.arrayOf(
    PropTypes.shape({
      src: PropTypes.string.isRequired,
      alt: PropTypes.string,
    })
  ).isRequired,
};
